// 部分迁移到这种方式，原来的api做法很不合适
import request from './request'

export function fetchMessages (pageIndex = 1, pageSize = 20) {
  return request({
    method: 'get',
    url: `/access/v1/user/message/list`,
    params: { pageIndex, pageSize }
  })
}

export function postMessageRead (id) {
  return request({
    method: 'post',
    url: `/access/v1/user/message/read/${id}`
  })
}

export function postMessageReadAll () {
  return request({
    method: 'post',
    url: '/access/v1/user/message/read'
  })
}

export function fetchMessageDetails (id) {
  return request({
    method: 'get',
    url: `/access/v1/user/message/show-order/${id}`,
  })
}

export function fetchMessageType6 (id) {
  return request({
    method: 'get',
    url: `/app/message/bet/grant/${id}`
  })
}

export function fetchMessageType78 (id) {
  return request({
    method: 'get',
    url: `/access/v1/user/message/first-order/${id}`
  })
}
